import type { useTranslation } from 'react-i18next'
import type { BriefingStep } from '@/shared/briefing'
import type { LvdBriefingStep } from '../../utils/lvdLegislationBriefing'

export function toV2LvdBriefingStep(
  step: LvdBriefingStep,
  translate: ReturnType<typeof useTranslation>['t']
): BriefingStep {
  return {
    key: step.key,
    status: step.status,
    requiredness: step.requiredness,
    title: translate(
      `v2.pages.products.detail.lvdBriefing.steps.items.${step.key}.title`
    ),
    description: translate(
      `v2.pages.products.detail.lvdBriefing.steps.items.${step.key}.description`
    ),
    requirednessLabel: translate(
      `v2.pages.products.detail.lvdBriefing.requiredness.${step.requiredness}`
    ),
  }
}
